import { render, staticRenderFns } from "./LeavingModal.vue?vue&type=template&id=567f9c5b&"
import script from "./LeavingModal.vue?vue&type=script&lang=js&"
export * from "./LeavingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports